import { FunctionComponent, useState } from 'react';
import { Button } from 'dibs-elements/exports/Button';

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SharedFAQQuestion } from './SharedFAQQuestion';
import { frequentlyAskedQuestions as frequentlyAskedQuestionsTitle } from '../../buy/buyMessages';
import { viewMore, viewLess } from '../../finding/sbMessages';
import { INITIAL_VISIBLE_QA_ITEMS } from '../../constants/sbConstants';

import { SharedFAQ_itemSearch$data } from './__generated__/SharedFAQ_itemSearch.graphql';

import styles from './SharedFAQ.scss';

type Props = {
    itemSearch: SharedFAQ_itemSearch$data;
};

const SharedFAQComponent: FunctionComponent<Props> = ({ itemSearch }) => {
    const [expanded, setExpanded] = useState(false);
    const limit = expanded ? undefined : INITIAL_VISIBLE_QA_ITEMS; // undefined means unlimited

    const questions = itemSearch?.questionsAnswers || [];
    const header = itemSearch?.meta?.header;

    if (questions.length) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.header} data-tn="faq-header">
                    {frequentlyAskedQuestionsTitle(header)}
                </div>

                <ul>
                    {questions.slice(0, limit).map((question, index) => (
                        <SharedFAQQuestion key={index} question={question} />
                    ))}
                </ul>

                {questions.length > INITIAL_VISIBLE_QA_ITEMS && (
                    <Button
                        type="secondary"
                        size="medium"
                        onClick={() => {
                            setExpanded(!expanded);
                        }}
                        className={styles.viewMoreButton}
                    >
                        {expanded ? viewLess : viewMore}
                    </Button>
                )}
            </div>
        );
    }

    return null;
};

export const SharedFAQ = createFragmentContainer(SharedFAQComponent, {
    itemSearch: graphql`
        fragment SharedFAQ_itemSearch on ItemSearchQueryConnection {
            meta {
                header
            }
            questionsAnswers {
                ...SharedFAQQuestion_question
            }
        }
    `,
});
